/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import FileItem from './file-item/file-item.component';

/**
 * Class representing the files list component.
 * @extends Component
 * */
class FilesList extends Component {

  /**
   * Bubble up to onGoTofile
   * @param {number} id - The file id.
   * */
  onGoToFile = (id) => {
    const { onGoToFile } = this.props;

    onGoToFile(id);
  };


  /**
   * Bubbles up the new selection state
   * @param {number} id - The file id.
   * @param {bool} selected - The new select state.
   * */
  onFileSelectChange = (id, selected) => {
    const { onFileSelectChange } = this.props;

    onFileSelectChange(id, selected);
  };

  render() {
    const { files, hideGoToFile } = this.props;

    if (files.length === 0) {
      return (
        <FontAwesomeIcon className="no-results" icon={faCloudUploadAlt} size="6x" />
      );
    }

    return (
      files.map(file => (
        <FileItem
          key={file.id}
          file={file}
          hideGoToFile={hideGoToFile}
          onGoToFile={this.onGoToFile}
          onCheckChange={this.onFileSelectChange}
        />
      ))
    );
  }
}

export default FilesList;

FilesList.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  hideGoToFile: PropTypes.bool.isRequired,
  onGoToFile: PropTypes.func.isRequired,
  onFileSelectChange: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/messages/dashboard/files-list/files-list.component.js